import React from 'react';
import About from './founderComp/About';
import Achievements from './founderComp/Achievements';
import Achievements2 from './founderComp/Achievements2';
import Banner from './founderComp/Banner';
import Footer from './founderComp/Footer';
import Qualifications from './founderComp/Qualifications';
import Skills from './founderComp/Skills';

function CeoPortfolio() {
	return (
		<div>
			<Banner />
			<About />
			<Achievements />
			{/* <Achievements2 /> */}
			<Qualifications />
			{/* <Skills /> */}
			<Footer />
		</div>
	);
}

export default CeoPortfolio;
